<!-- <div class="pdf-container">
  <pdf-viewer [src]="pdfSrc" [render-text]="true" [original-size]="false" class="pdf-viewer">
  </pdf-viewer>

</div> -->
<pdf-viewer [src]="pdfSrc" [render-text]="true" [original-size]="false" style="width: 100%; height: 100%">
</pdf-viewer>
